module.exports = __webpack_public_path__ + "static/section-4-2cb8fcb03f5337f9d66c76fadc63e6df.jpg";